import CrudCustom from '../../../libs/custom/CrudCustom';

let TipePajak = new CrudCustom('/tipe-pajaks');
export default TipePajak;
